exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".gantt-grid[data-v-4af40905] {\n  min-width: 200px;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  border-right: none;\n  height: 100%;\n  max-width: 50%;\n  overflow: hidden;\n  position: relative;\n}\n", ""]);

// exports
